import { UnleashClient, InMemoryStorageProvider } from 'unleash-proxy-client'
import { getUserTokenInfo } from '@/auth'
import { UNLEASH_CLIENT_KEY, UNLEASH_PROXY_URL } from './consts'

const unleashClient = new UnleashClient({
  url: UNLEASH_PROXY_URL,
  clientKey: UNLEASH_CLIENT_KEY,
  appName: 'Insights Frontend',
  storageProvider: new InMemoryStorageProvider(),
})

try {
  const userInfo = await getUserTokenInfo()
  unleashClient.setContextField('companyNameKey', userInfo.companyNameKey)
  unleashClient.setContextField('userId', userInfo.userId.toString())
} catch (error) {
  console.warn('Failed to set Unleash user context:', error)
}

try {
  await unleashClient.start()
} catch (error) {
  console.warn(
    'Unleash client failed to start, using default flag values:',
    error
  )
}

const isDashboardsSurveysEnabled = () => {
  return unleashClient.isEnabled('dashboards-surveys')
}

const isSchedulePerformanceTableTagsEnabled = () => {
  return unleashClient.isEnabled('schedule-performance-table-tags')
}

const trainingImpactDashboardEnabled = () => {
  return unleashClient.isEnabled('training-impact-dashboard')
}

const fastExamDashboardEnabled = () => {
  return unleashClient.isEnabled('fast-exam-dashboard')
}

const realTalkDashboardEnabled = () => {
  return unleashClient.isEnabled('realtalk-dashboard')
}

// Single opt-in gate for per-user RealTalk data: the User Transcript report AND
// the RealTalk dashboard's Users filter (INSI-1804). Replaced the old
// blacklist flag `realtalk-dashboard-users-filter-disabled`.
const realTalkUserTranscriptReportEnabled = () => {
  return unleashClient.isEnabled('realtalk-user-transcript-report')
}

const aiChatEnabled = () => {
  return unleashClient.isEnabled('ai-chat')
}

const newInsightsButtonEnabled = () => {
  return unleashClient.isEnabled('new-insights-button')
}

// INSI-2261: launch switch for sending the Completion Dashboard tab (/dashboard)
// to the new Insights app. Off = PowerBI as before. Companies kept on PowerBI
// are excluded in the flag's strategy with a constraint on the `companyNameKey`
// context field set above (see helpers/helper.powerBiRedirect.ts).
const powerBiDashboardRedirectEnabled = () => {
  return unleashClient.isEnabled('powerbi-dashboard-redirect')
}

const maintainence = () => {
  return unleashClient.isEnabled('maintainence')
}

const reportPreviewEnabled = () => {
  return unleashClient.isEnabled('report-preview')
}

const testErrorReportEnabled = () => {
  return unleashClient.isEnabled('test-error-report')
}

export {
  isDashboardsSurveysEnabled,
  isSchedulePerformanceTableTagsEnabled,
  trainingImpactDashboardEnabled,
  fastExamDashboardEnabled,
  realTalkDashboardEnabled,
  realTalkUserTranscriptReportEnabled,
  aiChatEnabled,
  reportPreviewEnabled,
  newInsightsButtonEnabled,
  powerBiDashboardRedirectEnabled,
  testErrorReportEnabled,
  maintainence,
}
